import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link, createSearchParams, useNavigate } from 'react-router-dom';
import AppConfig from '../../config';
import { t } from '../../lang';
import RequestService from '../../services/RequestService';

import { HistoryItemWithSkeleton } from '../Skeletons/ItemsWithSkeleton';
import './HistoryBlock.scss';

const { routes } = AppConfig;

const HistoryBlock = ({ currencyId = 0, addressId = 0, cardId = 0, historyCount = 3, useAsSkeleton }) => {
	const [transactions, setTransactions] = useState([]);
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const getCardHistory = async () => {
		try {
			setLoading(true);
			const response = await RequestService.GetTransationByCard(cardId, 1, historyCount, '', '', '', {
				by: 'Created',
				desc: true,
			});
			setLoading(false);
			if (response?.Status === 'Success') {
				setTransactions(response.Transactions);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getHistory = async () => {
		try {
			setLoading(true);
			const response = await RequestService.GetTransationByCurrency(
				currencyId,
				addressId,
				1,
				historyCount,
				'',
				'',
				'',
				{ by: 'Created', desc: true }
			);
			setLoading(false);
			if (response?.Status === 'Success') {
				setTransactions(response.Transactions);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		if (useAsSkeleton) return;
		if (cardId) {
			getCardHistory();
		} else getHistory();
	}, []);

	const openTransaction = transaction => {
		navigate({ pathname: routes.transactionDetails }, { state: { transaction } });
	};

	return (
		<div className='HistoryBlock FormBlock'>
			{!transactions.length && !loading && (
				<div className='HistoryBlock__empty'>{t("You don't have transactions")}</div>
			)}
			{(loading || transactions.length > 0) && (
				<>
					<div className='HistoryBlock__header'>
						<div className='HistoryBlock__title'>{t('Recent transactions')}</div>
						<Link
							to={{ pathname: routes.transactionsHistory, search: createSearchParams({ cardId }).toString() }}
							state={{ currencyId, addressId }}
						>
							{t('View all')}
						</Link>
					</div>
					<HistoryItemWithSkeleton loading={loading} items={transactions} onClick={openTransaction} />
				</>
			)}
		</div>
	);
};

HistoryBlock.propTypes = {
	currencyId: PropTypes.oneOfType([PropTypes.number, () => null]), //пробуем решить проблему отсутствия PropTypes.null
	addressId: PropTypes.number,
	cardId: PropTypes.number,
	historyCount: PropTypes.number,
};

export default HistoryBlock;
